import React, {useState, useEffect} from 'react';
import {Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography} from '@mui/material';

export default function MicrochipOrderDialog({ open, onClose, onConfirm, defaultEmail, defaultTemplate, clinic, quantity, supplierEmail }) {
    const [email, setEmail] = useState(defaultEmail || '');
    const [content, setContent] = useState('');

    // Rebuild the filled-in content every time the dialog opens (or its
    // inputs change). One state field = one source of truth, so the user
    // can edit the visible text without placeholders ever reappearing.
    useEffect(() => {
        if (!open) return;
        const safeClinicName = clinic?.clinicName || clinic?.business_name || '';
        const safeAddress = clinic?.address || clinic?.supplier_address || '';
        const safeContact = clinic?.contactName || clinic?.personal_name || '';
        const safeVetNumber = clinic?.vetNumber || clinic?.merco_id || clinic?.vendor_id || '';
        const filled = (defaultTemplate || '')
            .replace(/\[amount\]/g, quantity != null ? String(quantity) : '')
            .replace(/\[vet clinic name\]/g, safeClinicName)
            .replace(/\[address\]/g, safeAddress)
            .replace(/\[contact name\]/g, safeContact)
            .replace(/\[vet number\]/g, safeVetNumber);
        setContent(filled);
        setEmail(defaultEmail || '');
    }, [open, defaultEmail, defaultTemplate, clinic, quantity]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Order Microchips</DialogTitle>
            <DialogContent>
                <Typography variant="body2" gutterBottom>
                    Please confirm the order details and recipient email. You can edit the email or wording if needed.
                </Typography>
                {supplierEmail ? (
                    <Typography variant="body2" sx={{ mt: 1, mb: 1, color: 'text.secondary' }}>
                        Sending to supplier: <b>{supplierEmail}</b>
                    </Typography>
                ) : null}
                <TextField
                    label="Staff Member Placing Order"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Email Content"
                    value={content}
                    onChange={e => setContent(e.target.value)}
                    fullWidth
                    multiline
                    minRows={7}
                    margin="normal"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant="contained" onClick={() => onConfirm({ email, content })}>
                    Confirm &amp; Send
                </Button>
            </DialogActions>
        </Dialog>
    );
}
